import React from 'react';
import { Modifier } from 'react-day-picker';
import {
  RegisterOptions,
  useFormContext,
} from 'react-hook-form/dist/index.ie11';
import { DateInput } from 'src/components/enterprise/components/DateInput/DateInput';

export interface BaseDateInputProps {
  disabled?: boolean;
  id: string;
  name: string;
  label: string;
  rules?: RegisterOptions;
  disabledDays?: Modifier | Modifier[];
  initialMonth?: Date;
  blockWidth?: boolean;
}

export const BaseDateInput: React.FC<BaseDateInputProps> = ({
  disabled = false,
  id,
  name,
  label,
  rules,
  disabledDays,
  initialMonth,
  blockWidth = false,
}) => {
  const { errors, control } = useFormContext();

  return (
    <DateInput
      id={id}
      name={name}
      label={label}
      disabled={disabled}
      control={control}
      error={errors[name]}
      rules={rules}
      disabledDays={disabledDays}
      initialMonth={initialMonth}
      blockWidth={blockWidth}
    />
  );
};
